import { useAuthorizedQuery, useAuthorizedMutation } from "..";
import { params } from "../../params";

interface Agent {
  id: string;
  name: string;
  teams: string[];
  externalId: string;
}

interface TeamAgentsResponse {
  [teamName: string]: {
    id: string;
    name: string;
    agents: Agent[];
  };
}

interface TeamResponse {
  id: string;
  name: string;
}

interface ApiResponse {
  success: boolean;
  message: string;
}

interface DeleteTeamRequest {
  teamId: string;
}

interface RemoveAgentFromTeamRequest {
  agentId: string;
}

interface AddAgentToTeamRequest {
  agentId: string;
}

// Get all agents
export const useAgents = (enabled: boolean = true) => {
  return useAuthorizedQuery<Agent[]>({
    queryKey: "agents",
    url: `${params.API_URL}/platform/agent`,
    method: "GET",
    enabled,
  });
};

// Get teams with their agents
export const useTeamsWithAgents = (enabled: boolean = true) => {
  return useAuthorizedQuery<TeamAgentsResponse>({
    queryKey: "teamsWithAgents",
    url: `${params.API_URL}/platform/agent/teams`,
    method: "GET",
    enabled,
  });
};

// Create new team
export const useCreateTeam = () => {
  return useAuthorizedMutation<TeamResponse>({
    url: `${params.API_URL}/platform/agent/teams`,
    method: "POST",
  });
};

// Add agent to team
export const useAddAgentToTeam = (agentId: string, teamId: string) => {
  return useAuthorizedMutation<TeamResponse>({
    url: `${params.API_URL}/platform/agent/${agentId}/teams`,
    method: "PUT",
  });
};

// Remove agent from team
export const useRemoveAgentFromTeam = (agentId: string, teamId: string) => {
  return useAuthorizedMutation<any>({
    url: `${params.API_URL}/platform/agent/${agentId}/teams/${teamId}`,
    method: "DELETE",
  });
};

// Delete team
export const useDeleteTeam = (teamId: string) => {
  return useAuthorizedMutation<ApiResponse>({
    url: `${params.API_URL}/platform/agent/teams/${teamId}`,
    method: "DELETE",
  });
};
